'use strict';

var cov_cln59asgc = function () {
    var path = '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.config.js',
        hash = '60694b6c089f37481479bb48eca6acfe92ced560',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/coliseu-app/src/app/shared/js/ORM/tables.config.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 17,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 24
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 14,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 15,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 52
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 17,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'Config',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 19
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 50
                    },
                    end: {
                        line: 16,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_cln59asgc.s[0]++;
(function () {
    'use strict';

    cov_cln59asgc.f[0]++;
    cov_cln59asgc.s[1]++;
    angular.module('app').config(Config);

    /* @ngInject */
    function Config(restmodProvider, AppSettings) {
        cov_cln59asgc.f[1]++;
        cov_cln59asgc.s[2]++;

        restmodProvider.rebase({
            $config: {
                urlPrefix: AppSettings.apiUrl
            }
        });
        cov_cln59asgc.s[3]++;
        restmodProvider.rebase('DjangoDRFPagedApi');
    }
})();